// test619
(619 && 0);
